import { GroupedBar, StackedBar } from '@unovis/ts'
import { ChartDataSet, XYRecord } from '~/utils/charts/unovis'
import { seriesByType } from '~/utils/charts/zchart'

const DEFAULT_BAR_PADDING = 0.5
const MIN_BAR_PADDING = 0

type BuildBarSeriesComponentsOptions = {
  chartType: string
  dataSets: Array<ChartDataSet>
  palette: Array<string>
  x: (d: XYRecord) => number
  barOptions: { barPadding?: number; stacked?: number | boolean }
}

export const buildBarSeriesComponents = (
  options: BuildBarSeriesComponentsOptions
): Array<unknown> => {
  const { chartType, dataSets, palette, x, barOptions } = options
  const barIndices = seriesByType(chartType, dataSets, 'bar')
  if (!barIndices.length) return []

  const barAccessors = barIndices.map((index) => (d: XYRecord) => d.values[index] ?? null)
  const barColors = barIndices.map((index) => palette[index] || palette[0])
  const stacked = Boolean(barOptions?.stacked)
  const barPadding = Math.max(barOptions?.barPadding ?? DEFAULT_BAR_PADDING, MIN_BAR_PADDING)

  if (stacked) {
    return [new StackedBar<XYRecord>({ x, y: barAccessors, color: barColors, barPadding })]
  }
  return [new GroupedBar<XYRecord>({ x, y: barAccessors, color: barColors, barPadding })]
}
